// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"445":"4f8d63a2","895":"99ad4688"}[chunkId] + ".chunk.css";
};